import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { IoHome } from "react-icons/io5";
import './Contact.css'; // ניצור קובץ עיצוב במידת הצורך

const API = process.env.REACT_APP_API;

function Contact() {
    const navigate = useNavigate();

  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!formData.name.trim()) {
      errs.name = 'יש להזין שם מלא';
    }
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      errs.email = 'אימייל לא תקין';
    }
    if (!formData.phone.match("05?[0-9]?[0-9]{7}")) {
      errs.phone = "יש להזין מס' טלפון תקין (10 מספרים)";
    }
    if (formData.message.length < 10) {
      errs.message = 'ההודעה צריכה לכלול לפחות 10 תווים';
    }
    return errs;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: null });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error('🛑 יש למלא את הטופס כראוי');
      return;
    }
    try {
    const response = await fetch(`${API}/api/contact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      toast.success('✅ ההודעה נשלחה בהצלחה!');
      setFormData({ name: '', email: '', phone: '', message: '' });
      e.target.reset();
    } else {
      toast.error('🚫 שליחת ההודעה נכשלה');
    }
  } catch (error) {
    console.error(error);
    toast.error('❌ שגיאת תקשורת בשרת');
  }
  };

  return (
    <div className="container">
      <div className="home-icon" onClick={() => navigate("/")}>
          <IoHome title="עמוד הבית" size={30} />
      </div>
      <div className="contact-title">צרי קשר</div>
      <br />
      <form className="contact-form" onSubmit={handleSubmit}>
        <label>
            שם מלא:
          <input type="text" name="name" value={formData.name} onChange={handleChange} />
          {errors.name && <span className="error">{errors.name}</span>}
        </label>
        <label>
          אימייל:
          <input type="email" name="email" className="email-input" value={formData.email} onChange={handleChange} required/>
          {errors.email && <span className="error">{errors.email}</span>}
        </label>
        <label>
            טלפון:
          <input type="number" name="phone" value={formData.phone} onChange={handleChange} />
          {errors.phone && <span className="error">{errors.phone}</span>}
        </label>
        <label>
          מהות הפנייה:
          <textarea name="message" rows="5" value={formData.message} onChange={handleChange}></textarea>
          {errors.message && <span className="error">{errors.message}</span>}
        </label>
        <button type="submit">שליחה</button>
      </form>

    <br />
    </div>
  );
}

export default Contact;